import React, { useState, useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import Header from "../../../Components/Header";
import Footer from "../../../Components/Footer";
import "../Account.css";
import { FaUserCircle, FaAngleRight } from 'react-icons/fa';
import SweetAlert from "react-bootstrap-sweetalert";
import { BrowserView, MobileView } from "react-device-detect";
import AccountSidebar from "../AccountSidebar";


const Account = () => {

    return (
        <>
            <Header />

            <BrowserView>

                <div className="account-container">
                    {/* Sidebar */}
                    <AccountSidebar/>

                    {/* Main Content */}
                    <div className="account-content">
                        <Outlet />
                        <div className="col-lg-12">
                            <div className="acpanel">
                                <div className="acpanel-header">
                                    <h4>Account Overview</h4>
                                </div>
                                <div className="acpanel-body">
                                    <div className="row mb-3">
                                        <div className="col-lg-4">
                                            <Link to="/account/my-profile" className="aobox" style={{ textDecoration: "none" }}>
                                                <img src="img/user.png" className="mb-1" />
                                                <h5 style={{ color: "green" }}>Profile</h5>
                                                <p style={{ color: "black", fontSize: "14px" }} className="mb-0">Manage your account information</p>
                                            </Link></div>
                                        <div className="col-lg-4">
                                            <Link to="/account/address" className="aobox" style={{ textDecoration: "none" }}>
                                                <img src="img/pin.png" className="mb-1" />
                                                <h5 style={{ color: "green" }}>Address</h5>
                                                <p style={{ color: "black", fontSize: "14px" }} className="mb-0">Saved addresses for hassle-free booking</p>
                                            </Link></div>
                                        <div className="col-lg-4">
                                            <Link to="/account/wallet" className="aobox" style={{ textDecoration: "none" }}>
                                                <img src="img/wallet.png" className="mb-1" />
                                                <h5 style={{ color: "green" }}>My Wallet</h5>
                                                <p style={{ color: "black", fontSize: "14px" }} className="mb-0">Add Money to Your Wallet</p>
                                            </Link></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <Link to="/account/my-bookings" className="aobox" style={{ textDecoration: "none" }}>
                                                <img src="img/order.png" className="mb-3" />
                                                <h5 style={{ color: "green" }}>My Bookings</h5>
                                                <p style={{ color: "black", fontSize: "14px" }} className="mb-0">Check your booking status</p>
                                            </Link></div>
                                        <div className="col-lg-4"><Link to="/account/change-password" className="aobox" style={{ textDecoration: "none" }}>
                                            <img src="img/changepassword.png" className="mb-3" />
                                            <h5 style={{ color: "green" }}>Change Password</h5>
                                            <p style={{ color: "black", fontSize: "14px" }} className="mb-0">Keep your account secure</p>
                                        </Link></div>
                                        <div className="col-lg-4">
                                            <Link to="/account/help-support" className="aobox" style={{ textDecoration: "none" }}>
                                                <img src="img/helpsupport.png" className="mb-1" />
                                                <h5 style={{ color: "green" }}>Help &amp; Support</h5>
                                                <p style={{ color: "black", fontSize: "14px" }} className="mb-0">Help regarding recent purchase &amp; other</p>
                                            </Link></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </BrowserView>

            <MobileView>
                <AccountSidebar/>
            </MobileView>


          

            {/* <Footer /> */}
        </>

    );
};

export default Account;
